import { gql, GraphQLClient } from 'graphql-request'
import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'

const query = gql`
  mutation GRUPO_MEDIDA_ELIMINAR($id: ID!) {
    grupoUnidadMedidaEliminar(id: $id)
  }
`
export const apiEliminarGrupoUnidadMedida = async (id: string): Promise<boolean> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    client.setHeader('authorization', `Bearer ${token}`)
    const data: any = await client.request(query, { id })
    return data.grupoUnidadMedidaEliminar
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
